import { connect } from 'react-redux';

import CognitoFormsCSVButton from '../components/CognitoFormsCSVButton';
import { downloadCognitoFormsCSV } from '../../../../../state/modules/cognitoForms/actions';

const mapStateToProps = (state) => {
  return {
    isDownloading: state.cognitoForms.get('isCSVDownloading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    download: (order, filter, cb) => {
      dispatch(downloadCognitoFormsCSV(order, filter, cb));
    },
  };
};
const CognitoFormsCSVButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormsCSVButton);

export default CognitoFormsCSVButtonContainer;
